import { render, staticRenderFns } from "./PrimaryColorPicker.vue?vue&type=template&id=02695414&scoped=true"
import script from "./PrimaryColorPicker.vue?vue&type=script&lang=js"
export * from "./PrimaryColorPicker.vue?vue&type=script&lang=js"
import style0 from "./PrimaryColorPicker.vue?vue&type=style&index=0&id=02695414&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02695414",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/dev.ideabuddy.com/public_html/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('02695414')) {
      api.createRecord('02695414', component.options)
    } else {
      api.reload('02695414', component.options)
    }
    module.hot.accept("./PrimaryColorPicker.vue?vue&type=template&id=02695414&scoped=true", function () {
      api.rerender('02695414', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Settings/components/PrimaryColorPicker.vue"
export default component.exports